<div
  class="node-container circle"
  [ngClass]="focusClass"
  data-testid="htc-node-container">
  <div class="node-bg circle center"></div>
  <div class="node-text center">...</div>
</div>
